import styled, { css } from "styled-components";
import { propStyling, PropsWithPropStyling, tombac } from "../../../shared";
import { Container } from "./Container";

export type ButtonLabelProps = PropsWithPropStyling<{ withAddon: boolean }>;

export const Label = styled.span<ButtonLabelProps>`
  ${({
    theme: {
      components: {
        button: { current },
      },
    },
  }) => css<ButtonLabelProps>`
    all: initial;

    cursor: inherit;
    margin: ${({ withAddon }) => tombac.space(0, withAddon ? 1 : 0)};
    transition: 0.1s ease-out;
    transition-property: color, opacity;
    white-space: nowrap;
    z-index: 1;

    ${tombac.altText({
      color: tombac.parse(current!.color),
      fontSize: current!.fontSize,
      fontWeight: 700,
    })}

    ${Container}:hover && {
      color: ${tombac.parse(current!.hover?.color)};
    }

    ${Container}:disabled && {
      color: ${tombac.parse(current!.disabled?.color)};
    }

    ${propStyling}
  `}
`;
